var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vi-page',[_c('div',[_vm._v(_vm._s(_vm.text))]),_c('a',{ref:"rA",staticClass:"hidden",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.url))])])
}
var staticRenderFns = []

export { render, staticRenderFns }